/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { SelectableResourceService } from '@well/common-libs/selectable-resource-management/util';
import { UnitMeasurementSelectableResourceService } from './unit-measurement-selectable-resource.service';

export const unitMeasurementSelectableResourceProviders = [
  {
    provide: SelectableResourceService,
    useClass: UnitMeasurementSelectableResourceService,
    multi: true,
  }
];
